import { render, staticRenderFns } from "./TextRecordProgressBar.vue?vue&type=template&id=9a5aa1fa"
import script from "./TextRecordProgressBar.vue?vue&type=script&lang=js"
export * from "./TextRecordProgressBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports